import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// STAFF OBJECTIVES AND GOALS VERIFICATION RELATED APIs
// ==============================================

// 1. Get Verify Objects And Goals Inbox (GET)
export const getVerifyObjectsAndGoals = async (params) => {
    try {
        const { roleId } = params;
         // DEBUG
        
        // Validate required parameters
        if (!roleId) {
            throw new Error('RoleID is required');
        }
        
        const queryParams = new URLSearchParams({
            RoleId: roleId.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetVerifyObjectsAndGoals?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get Appraisal by ID (GET)
export const getAppraisalById = async (params) => {
    try {
        const { id, empRefNo } = params;
         // DEBUG
        
        // Validate required parameters
        if (!id) {
            throw new Error('ID is required');
        }
        if (!empRefNo) {
            throw new Error('EmpRefNo is required');
        }
        
        const queryParams = new URLSearchParams({
            Id: id.toString().trim(),
            EmpRefNo: empRefNo.toString().trim()
        });
        
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/HR/GetAppraisalbyId?${queryParams}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Approve Emp Objects (PUT)
export const approveEmpObjects = async (params) => {
    try {
         // DEBUG
        
        // Validate required parameters
        if (!params.EmpRefNo) {
            throw new Error('EmpRefNo is required');
        }
        if (!params.Id) {
            throw new Error('Id is required');
        }
        if (!params.RoleId) {
            throw new Error('RoleId is required');
        }
        if (!params.Createdby) {
            throw new Error('Createdby is required');
        }
        if (!params.Action) {
            throw new Error('Action is required');
        }
        
        const payload = {
            EmpRefNo: params.EmpRefNo.toString().trim(),
            Id: parseInt(params.Id),
            Remarks: params.Remarks?.toString().trim() || '',
            Year: params.Year ? parseInt(params.Year) : 0,
            Month: params.Month ? parseInt(params.Month) : 0,
            CCCode: params.CCCode?.toString().trim() || '',
            RoleId: parseInt(params.RoleId),
            Createdby: params.Createdby.toString().trim(),
            Action: params.Action.toString().trim(),
            Note: params.Note?.toString().trim() || ''
        };
        
         // DEBUG
         // DEBUG
        
        const response = await axios.put(
            `${API_BASE_URL}/HR/ApproveEmpObjects`,
            payload,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};